import * as types from '../types'
const state = {
  rongtoken: JSON.parse(localStorage.getItem('rongtoken')) || {},
  rongtoken_state: JSON.parse(localStorage.getItem('rongtoken_state')) || false
}
const actions = {
  set_rongtoken({commit, state}, res) {
    localStorage.setItem('rongtoken',res);
    commit(types.SET_RONGYUN_SET, res);
    commit(types.SET_RONGYUN_SET_STATE, true);
    localStorage.setItem('rongtoken_state', true);
  },
  del_rongtoken({commit, state}, res) {
    localStorage.removeItem(res);
    commit(types.SET_RONGYUN_SET, res);
    commit(types.SET_RONGYUN_SET_STATE, false);
    localStorage.setItem(res, false);
  }

}
const getters = {
  rongtoken: state => state.rongtoken,
  rongtoken_state: state => state.rongtoken_state
}

const mutations = {
  [types.SET_RONGYUN_SET](state, res) {
    state.rongtoken = res
  },
  [types.SET_RONGYUN_SET_STATE](state, res) {
    state.rongtoken_state = res
  }
}
export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/rongtoken.js